import classNames from 'classnames'
import AvatarPicker from '@/components/UI/AvatarPicker/AvatarPicker'
import React, { memo, useEffect, useRef, useState, useMemo } from 'react'
import {
  Button,
  ButtonGroup,
  Col,
  Row,
  Tab,
  Tabs,
  Image,
} from 'react-bootstrap'
import Select from 'react-select'
import {
  Checkbox,
  FormControlLabel,
  Button as MuiButton,
  Stack,
  Box,
  IconButton,
  Typography,
} from '@mui/material'
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded'
import CloseIcon from '@mui/icons-material/Close'
import AddIcon from '@mui/icons-material/Add'
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined'
import ImageIcon from '@mui/icons-material/Image'
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary'
import LinkIcon from '@mui/icons-material/Link'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { useHistory } from 'react-router'
import { useTranslation } from 'react-i18next'
import * as _ from 'lodash'
import { Container as DragContainer, Draggable } from 'react-smooth-dnd'
import { v4 as uuidv4 } from 'uuid'

import {
  getAllButtonOptions,
  getAllUserGroups,
} from '@/store/questions/actions'
import {
  generateQuestionBankV2,
  getLinkedQuestionsBasedOnQuizAndQuestions,
  getQuizFeatures,
  updateQuiz as updateQuizAction,
} from '@/store/quizzes/actions'
import { getQuizByQuizId } from '@/store/dashboard/actions'
import {
  addEntityToKnowledgeGroup,
  bulkAssignModules,
  exportQuizzesAndQuestions,
} from '@/store/knowledge/actions'
import { getButtonOptions } from '@/store/questions/selector'
import { HelperService } from '@/services/helper.service'
import QuizService from '@/services/QuizService'
import CommonService from '@/services/CommonService'
import KnowledgeService from '@/services/KnowledgeService'
import { TwoButtonModal } from '@/components/UI/Common'
import ConfirmationModal from '@/components/UI/ConfirmationModal/ConfirmationModal'
import PermissionWrapper from '@/components/UI/PermissionWrapper/PermissionWrapper'
import Loading from '@/components/UI/Loading/Loading'
import { Contenteditable } from '@/components/UI/Contenteditable/Contenteditable'
import RichMarkdownContent from '@/components/UI/RichMarkdownContent'
import KGroupsTree from '@/components/UI/KGroupsTree'
import ChildPageHeader from '@/components/UI/ChildPageHeader'
import SectionHeader from '@/components/UI/SectionHeader'
import Toggle from '@/components/UI/Toggle'
import ReportAlerts from './QuizAlerts'
import ScoreRange from './ScoreRange'
import FeedbackAndTutoring from './FeedbackAndTutoring/FeedbackAndTutoring'
import QuizQuestionEditor from './QuizQuestionEditor/QuizQuestionEditor'
import QuizDocumentPreview from './QuizDocumentPreview'
import CreateQuestionsOptions from './QuizQuestionBank/CreateQuestionsOptions'
import SkillsAssetment from './OldPortalComponents/SkillsAssetment'
import infoIcon from '@/assets/New-images/infor-red-circle.svg'
import dropDownBlue from '@/assets/New-images/dropdown-arow-blue.svg'
import './styles.scss'

const quizService = new QuizService()
const commonService = new CommonService()
const knowledgeService = new KnowledgeService()

const SectionTypography: React.FC<{ title: string; subtitle: string }> = memo(
  ({ title, subtitle }) => {
    return (
      <>
        <Typography variant="subtitle2" component="p">
          {title}
        </Typography>
        <Typography variant="body1" sx={{ fontWeight: 400 }}>
          {subtitle}
        </Typography>
      </>
    )
  },
)

function EditCreateQuiz(props: any) {
  const { t } = useTranslation()
  const helper = new HelperService()
  const emptyQuestion: any = {
    is_saved: false,
    type: 'radio',
    text: '',
    score: 1,
    options: [
      {
        text: '',
        is_correct: false,
      },
      {
        text: '',
        is_correct: false,
      },
    ],
  }
  const isCreateFromTestFile = props.location.state?.createFromTestFile
  const history = useHistory()
  const useLocatio = useLocation()
  const dispatch = useDispatch()
  const buttonOptionsSelector = useSelector(getButtonOptions)

  // handle active tab
  const queryParams = new URLSearchParams(history.location.search)
  const defaultTab = 'admins'
  const [activeTab, setActiveTab] = useState(
    queryParams.get('activeTab') || defaultTab,
  )
  const fromQuizExtraction = queryParams.get('fromQuizExtraction') === 'true'

  const [selectedGroupId, setSelectedGroupId] = useState(null)
  const [isGroupValid, setIsGroupValid] = useState(false)

  const [IsLoading, setIsLoading] = useState(false)
  const [isLoad, setIsLoad] = useState(false)
  const [isLoadingScenario, setIsLoadingScenario] = useState(false)
  const [transformedQuestions, setTransformedQuestions] = useState([])
  const [savedQuestions, setSavedQuestions] = useState([])
  const [quizDetail, setQuizDetail] = useState(null)
  const [quizName, setQuizName] = useState('')
  const [displayMode, setDisplayMode] = useState('single_question')
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false)
  const [toBeDeleted, setToBeDeleted] = useState([])
  const [addNew, setAddNew] = useState(false)
  const [quizDescription, setQuizDescription] = useState('')
  const [showAnswer, setShowAnswer] = useState(true)
  const [conditions, setConditions] = useState([])
  const [quizQuestionDropdownData, setQuizQuestionDropdownData] = useState([])
  const [buttonOptions, setButtonOptions] = useState([])
  const [questionIdLabelMap, setQuestionIdLabelMap] = useState({})
  const [hideMarks, setHideMarks] = useState(false)
  const [showScore, setShowScore] = useState(true)
  const [showScoreInPercentage, setShowScoreInPercentage] = useState(false)
  const [questionCount, setQuestionCount] = useState(null)
  const [showMainButton, setShowMainButton] = useState(true)
  const [mainButtonLabel, setMainButtonLabel] = useState('Continue to chat')
  const [markQuizRequired, setMarkQuizRequired] = useState(false)
  const [totalQuizScore, setTotalQuizScore] = useState(0)
  const [isWelcomeEnabled, setIsWelcomeEnabled] = useState(true)
  const [selectedQuizLabels, setSelectedQuizLabels] = useState([])
  const [enableLearning, setEnableLearning] = useState(false)
  const [decimalPlaces, setDecimalPlaces] = useState('2')
  const [updatingQuizQuestionsFromParent, SetUpdatingQuizQuestionsFromParent] =
    useState(false)
  const [hasAnyError, setHasAnyError] = useState([])
  const [componentHasError, setComponentHasError] = useState([])
  const [quizSubmitted, setQuizSubmitted] = useState(false)
  const [quizTotalScore, setQuizTotalScore] = useState(0)
  const ref = useRef([])
  const backupRef = useRef([])
  const [selectedNodes, setSelectedNodes] = useState([])
  const [showSaveQuestionsToQuestionBank, setShowSaveQuestionsToQuestionBank] =
    useState(false)
  const [showKNowledgebaseOrNot, setShowKNowledgebaseOrNot] = useState(false)
  const [essayGrader, setEssayGrader] = useState(null)
  const [essayConfig, setEssayConfig] = useState(null)
  const [isSaving, setSaving] = useState(false)
  // New state for Role play feedback
  const [scoreAnswers, setScoreAnswers] = useState(true)

  const [docContent, setDocContent] = useState(
    props.location &&
      props.location.state &&
      props.location.state.documentContent
      ? props.location.state?.documentContent
      : '',
  )
  const [documentId, setDocumentId] = useState([])
  const [rolePlayGoal, setRolePlayGoal] = useState('')
  const [rolePlayTutorRole, setRolePlayTutorRole] = useState('')
  const [rolePlayLearnerRole, setRolePlayLearnerRole] = useState('')
  const [rolePlayScenarioDescription, setRolePlayScenarioDescription] =
    useState('')
  const [rolePlayAvatarId, setRolePlayAvatarId] = useState('')
  const [selectedVoiceProfile, setSelectedVoiceProfile] = useState<any>({
    value: 'azure-male-01',
    label: 'Male Voice 1',
  })
  const [agentData, setAgentData] = useState<any>({ settings: {} })
  const [generatedScenario, setGeneratedScenario] = useState('')

  const [tableValues, setTableValues] = useState([
    {
      text: '',
      keyword_scores: {},
      score: 1,
    },
    {
      text: '',
      keyword_scores: {},
      score: 1,
    },
    {
      text: '',
      keyword_scores: {},
      score: 1,
    },
  ])

  const [idealAnswerItems, setIdealAnswerItems] = useState([
    { text: '', keyword_scores: {}, score: 1 },
    { text: '', keyword_scores: {}, score: 1 },
  ])
  const [newTableRowCount, setNewTableRowCount] = useState(0)
  const [newTableColumnCount, setNewTableColumnCount] = useState(3)

  const voiceProfiles = useMemo(() => {
    const baseProfiles = [
      {
        value: 'azure-male-01',
        label: 'Male Voice 1 (US)',
      },
      {
        value: 'azure-male-02',
        label: 'Male Voice 2 (UK)',
      },
      {
        value: 'azure-male-03',
        label: 'Male Voice 3 (AUS)',
      },
      {
        value: 'azure-female-01',
        label: 'Female Voice 1 (US)',
      },
      {
        value: 'azure-female-02',
        label: 'Female Voice 2 (UK)',
      },
      {
        value: 'azure-female-03',
        label: 'Female Voice 3 (AUS, English only)',
      },
    ]

    // Add Malaysian voice options if language_code is ms
    if (agentData?.language_code === 'ms') {
      return [
        {
          value: 'azure-male-ms-01',
          label: 'Male Voice (Bahasa Melayu)',
        },
        {
          value: 'azure-female-ms-01',
          label: 'Female Voice (Bahasa Melayu)',
        },
        ...baseProfiles,
      ]
    }

    return baseProfiles
  }, [agentData?.language_code])

  useEffect(() => {
    if (buttonOptionsSelector && buttonOptionsSelector.length) {
      setButtonOptions([...buttonOptionsSelector])
    }
  }, [buttonOptionsSelector])

  // Sync voice profile from agentData when it's loaded
  useEffect(() => {
    if (agentData?.settings?.voice_profile && voiceProfiles.length > 0) {
      const voiceProfile = voiceProfiles.find(
        (voice: any) => voice.value === agentData.settings.voice_profile,
      )
      if (voiceProfile) {
        setSelectedVoiceProfile(voiceProfile)
      }
    }
  }, [agentData?.settings?.voice_profile, voiceProfiles])

  // Sync voice profile from quiz detail when quizDetail and voiceProfiles are loaded
  useEffect(() => {
    if (
      quizDetail?.type === 'roleplay' &&
      quizDetail?.voice_profile &&
      voiceProfiles.length > 0
    ) {
      const voiceProfile = voiceProfiles.find(
        (voice: any) => voice.value === quizDetail.voice_profile,
      )
      if (voiceProfile) {
        setSelectedVoiceProfile(voiceProfile)
      }
    }
  }, [quizDetail?.voice_profile, quizDetail?.type, voiceProfiles])

  useEffect(() => {
    const query = new URLSearchParams(useLocatio.search)
    const document = query.get('document')
    if (document) {
      const doc = document.split(',')
      setDocumentId([...doc])
    }
    if (
      props.location &&
      props.location.state &&
      !props.location.state.selectedFileType
    ) {
      setShowSaveQuestionsToQuestionBank(true)
    }

    if ('undefined' === typeof props.location.state) {
      setShowSaveQuestionsToQuestionBank(true)
    }
  }, [props.location])

  useEffect(() => {
    let quizId = props.quizId ? props.quizId : props.match.params.quizId
    getQuiz(quizId)
    dispatch(getAllButtonOptions(true))
    dispatch(getAllUserGroups())
    getLearningFeature()
    if (
      typeof props.location.state !== 'undefined' &&
      props.location.state.selectedFileType &&
      props.location.state.quizArray &&
      props.location.state.quizArray.questions
    ) {
      backupRef.current = props.location.state.quizArray.questions
      transformAllQuestions(props.location.state.quizArray.questions)
      generateQuestionIdLabelMap(props.location.state.quizArray.questions)
      transformQuizDropdownData(props.location.state.quizArray.questions)
      setSavedQuestions(props.location.state.quizArray.questions)
      if (!props.location.state?.createFromTestFile) {
        helper.showToaster(
          t(
            'Questions imported successfully. You can now edit the questions/answers. Click on "Save" to save this quiz?',
          ),
          'success',
        )
      }
    }
  }, [])

  const getLearningFeature = async () => {
    try {
      const response: any = await dispatch(getQuizFeatures())
      if (response.features && response.features.length !== 0) {
        setEssayGrader(
          response.features.findIndex(
            (feature: any) => feature.name === 'essay_grader',
          ) >= 0,
        )
        setEssayConfig(
          response.features.find(
            (feature: any) =>
              feature?.name === 'essay_grader' && feature?.status === 'active',
          ),
        )
        for (let i = 0; i < response.features.length; i++) {
          if (response.features[i].name === 'learning') {
            setEnableLearning(true)
            break
          }
        }
      } else {
        setEnableLearning(false)
      }
    } catch (error) {
      setEnableLearning(false)
    }
  }

  const onAnswerKeyTableChange = (
    value: any,
    rowCount: any,
    columnCount: any,
  ) => {
    setIdealAnswerItems(value)
    setNewTableRowCount(rowCount)
    setNewTableColumnCount(columnCount)
  }

  const getQuiz = async (quizId: string) => {
    try {
      setIsLoading(true)
      setIsLoad(false)
      const { quizDetail }: any = await dispatch(getQuizByQuizId(quizId))

      // Fetch agent settings - important for avatar selection and display
      try {
        const agentSettingsResponse: any =
          await knowledgeService.getAgentSettings()
        if (
          agentSettingsResponse?.status === 200 &&
          agentSettingsResponse?.data?.data?.agent
        ) {
          const agent = agentSettingsResponse.data.data.agent
          setAgentData(agent)
        }
      } catch (error) {
        console.error('Failed to fetch agent settings:', error)
      }

      if (quizDetail.type === 'roleplay') {
        const {
          roleplay_goal,
          roleplay_learner_role,
          roleplay_scenario_description,
          roleplay_tutor_role,
          answer_key_settings,
          ideal_answer_items,
        } = quizDetail.questions[0]
        setRolePlayGoal(roleplay_goal ?? '')
        setRolePlayLearnerRole(roleplay_learner_role ?? '')
        setRolePlayScenarioDescription(roleplay_scenario_description ?? '')
        setRolePlayTutorRole(roleplay_tutor_role ?? '')
        if (quizDetail.avatar_id) {
          setRolePlayAvatarId(quizDetail.avatar_id)
        }
        // Set voice profile from quiz detail will be handled by useEffect
        if (ideal_answer_items && ideal_answer_items.length > 0) {
          setTableValues(ideal_answer_items)
          setIdealAnswerItems(ideal_answer_items)
        }
        if (answer_key_settings) {
          setNewTableRowCount(answer_key_settings.row_count)
        }
      }

      setQuizDetail(quizDetail)
      setQuizName(quizDetail.name)
      setQuizDescription(quizDetail.description ?? '')
      setDisplayMode(quizDetail.display_mode)
      setSelectedGroupId(
        quizDetail.knowledge_group_ids.length > 0
          ? quizDetail.knowledge_group_ids[0]
          : null,
      )

      if (quizDetail.display_score != null) {
        setHideMarks(!quizDetail.display_score)
      } else {
        setHideMarks(false)
      }

      if (quizDetail.display_questions_count) {
        setQuestionCount(quizDetail.display_questions_count.toString())
      } else {
        setQuestionCount(null)
      }

      if (
        'score_decimal_number' in quizDetail &&
        quizDetail.score_decimal_number !== null
      ) {
        setDecimalPlaces(quizDetail.score_decimal_number.toString())
      } else {
        setDecimalPlaces('2')
      }

      if (quizDetail && quizDetail.questions.length) {
        setQuizTotalScore(quizDetail?.provisional_question_score)
      }

      if (quizDetail.is_required) {
        setMarkQuizRequired(quizDetail.is_required)
      }

      if (quizDetail.result_settings) {
        setShowAnswer(quizDetail.result_settings.show_answers)
        // Initialize Role play feedback (default true if not provided)
        if (
          'score_answers' in quizDetail.result_settings &&
          quizDetail.result_settings.score_answers !== null
        ) {
          setScoreAnswers(!!quizDetail.result_settings.score_answers)
        } else {
          setScoreAnswers(true)
        }
        setShowScore(quizDetail.result_settings.show_scores)
        setShowScoreInPercentage(
          quizDetail.result_settings.show_scores_in_percentage,
        )
        setShowMainButton(quizDetail.result_settings.show_button)
        setMainButtonLabel(quizDetail.result_settings.button_label)

        let temp = []
        temp = addIdToConditions(quizDetail.result_settings.conditions)
        setConditions(temp)
      }

      if (quizDetail.questions && quizDetail.questions.length > 0) {
        backupRef.current = quizDetail.questions
        transformAllQuestions(quizDetail.questions)
        generateQuestionIdLabelMap(quizDetail.questions)
        transformQuizDropdownData(quizDetail.questions)
        setSavedQuestions(quizDetail.questions)
      } else {
        if (
          typeof props.location.state !== 'undefined' &&
          !props.location.state.selectedFileType
        ) {
          addNewQuestion()
        }
      }

      if (quizDetail.questions) {
        computeTotalScore(quizDetail.questions)
      }

      if ('is_welcome_enabled' in quizDetail) {
        setIsWelcomeEnabled(quizDetail.is_welcome_enabled)
      }

      if (quizDetail.labels) {
        let temp = []
        temp = quizDetail.labels.map((item: any) => ({
          label: item,
          value: item,
        }))
        setSelectedQuizLabels(temp)
      }
      setIsLoading(false)
    } catch (error) {
    } finally {
      setIsLoading(false)
    }
  }

  const transformAllQuestions = (questions: any) => {
    let temp: any = {}
    questions.forEach((question: any, index: number) => {
      if (question.parent_id && temp[question.parent_id]) {
        temp[question.parent_id] = {
          ...temp[question.parent_id],
          subquestions:
            'subquestions' in temp[question.parent_id]
              ? temp[question.parent_id].subquestions.concat([question])
              : [].concat([question]),
        }
      } else {
        temp[question.id ? question.id : uuidv4()] = question
      }
    })
    setTransformedQuestions(temp)
  }

  const computeTotalScore = (questions: any) => {
    let totalScore = 0

    questions.forEach((question: any) => {
      if (question.score) {
        totalScore += question.score
      }
    })

    setTotalQuizScore(totalScore)
  }

  const transformQuizDropdownData = (questions: any) => {
    let quizDropdown: any = []

    questions.forEach((item: any, index: number) => {
      if (item && item.text) {
        quizDropdown.push({
          value: item.id,
          label: <RichMarkdownContent contextText={item.text} />,
        })
      }
    })

    setQuizQuestionDropdownData(quizDropdown)
  }

  const generateQuestionIdLabelMap = (questions: any) => {
    let tempMap: any = {}
    questions.forEach((question: any, index: number) => {
      tempMap[question.id] = {
        label: <RichMarkdownContent contextText={question.text} />,
        options: question.options,
        type: question.type,
      }
    })

    setQuestionIdLabelMap(tempMap)
  }

  ///////////////////// QUIZ SETTINGS ////////////////////
  const removeScoreCondition = (conditionIndex: number) => {
    let temp = [...conditions]
    temp.splice(conditionIndex, 1)
    setConditions([...temp])
  }

  const addScoreRangeCondition = (isFeedback: boolean = false) => {
    if (isFeedback && quizQuestionDropdownData.length === 0) {
      return
    }
    let temp = [...conditions]
    temp.push({
      id: uuidv4(),
      test: isFeedback
        ? {
            max_score: 0,
            min_score: 0,
            question_id: quizQuestionDropdownData[0].value,
          }
        : {},
      show: {},
    })
    setConditions([...temp])
  }

  const addIdToConditions = (data: any) => {
    let temp: any = []
    data.forEach((item: any, index: number) => {
      if (!item.id) {
        temp[index] = {
          ...item,
          id: uuidv4(),
        }
      } else {
        temp[index] = { ...item }
      }
    })
    return temp
  }

  const onFieldChange = (value: any, key: string) => {
    if (key === 'name') {
      setQuizName(value)
    }
  }

  const onQuizDescriptionChange = (value: string) => {
    setQuizDescription(value)
  }

  const transformData = (data: any) => {
    let temp: any = []
    data.forEach((element: any) => {
      if (!element.buttonId) {
        temp.push({
          ...element,
          buttonId: uuidv4(),
        })
      } else {
        temp.push({
          ...element,
        })
      }
    })
    return temp
  }

  const onConditionQuestionDropdownChange = (
    value: any,
    key: any,
    conditionIndex: any,
  ) => {
    let temp = [...conditions]
    if (key === 'quizQuestion') {
      if (value === 0) {
        temp[conditionIndex].test = {}
      } else {
        temp[conditionIndex].test = {
          question_id: value,
        }
      }
    } else if (key === 'requiresCorrect') {
      if (value === 'correct' || value === 'incorrect') {
        temp[conditionIndex].test = {
          question_id: temp[conditionIndex].test.question_id,
          requires_correct: value === 'correct',
        }
      } else {
        temp[conditionIndex].test = {
          question_id: temp[conditionIndex].test.question_id,
          option_id: value,
          is_chosen: true,
        }
      }
    }
    setConditions(temp)
  }

  const onConditionFieldChange = (
    value: any,
    key: any,
    conditionIndex: any,
  ) => {
    let temp = [...conditions]
    if (key === 'minScore') {
      temp[conditionIndex].test = {
        ...temp[conditionIndex].test,
        min_score: parseFloat(value),
      }
    } else if (key === 'maxScore') {
      temp[conditionIndex].test = {
        ...temp[conditionIndex].test,
        max_score: parseFloat(value),
      }
    } else if (key === 'message') {
      temp[conditionIndex].show.message = value
    } else if (key === 'userGroup') {
      if (value) {
        temp[conditionIndex].trigger = {
          name: 'add-user-to-group',
          data: {
            group_id: value,
          },
        }
      } else {
        temp[conditionIndex].trigger = {}
      }
    }
    setConditions([...temp])
  }

  const onButtonAdd = (data: any, conditionIndex: any) => {
    let temp = [...conditions]
    let tempButtons: any = []
    if (temp[conditionIndex].show.buttons) {
      tempButtons = [...temp[conditionIndex].show.buttons]
    }
    tempButtons.push(data)

    temp[conditionIndex].show.buttons = tempButtons

    setConditions(temp)
  }

  const onButtonLabelEdit = (event: any, id: any, conditionIndex: any) => {
    let temp = [...conditions]

    let tempButtons = [...temp[conditionIndex].show.buttons]
    tempButtons[id].label = event.target.value

    temp[conditionIndex].show.buttons = tempButtons

    setConditions(temp)
  }

  const onButtonQuestionSelect = (
    value: any,
    index: any,
    conditionIndex: any,
  ) => {
    let temp = [...conditions]

    let tempButtons = [...temp[conditionIndex].show.buttons]
    let [button_type, button_value] = value.value.split('::')

    tempButtons[index].type = button_type

    if ('question' === button_type) {
      tempButtons[index].question = button_value
    } else {
      tempButtons[index].reference_id = button_value
    }

    temp[conditionIndex].show.buttons = tempButtons

    setConditions(temp)
  }

  const deleteButtonRow = (id: any, conditionIndex: any) => {
    let temp = [...conditions]

    let tempButtons = [...temp[conditionIndex].show.buttons]
    tempButtons.splice(id, 1)

    temp[conditionIndex].show.buttons = tempButtons

    setConditions(temp)
  }

  const onSort = (data: any, conditionIndex: any) => {
    try {
      let temp = [...conditions]
      let condition = temp[conditionIndex]
      if (condition && condition.show && condition.show.buttons) {
        temp[conditionIndex].show.buttons = [...data]
      } else {
        const updatedCondition = {
          ...condition,
          show: {
            ...condition.show,
            buttons: [...data],
          },
        }
        temp[conditionIndex] = updatedCondition
      }
      setConditions(temp)
    } catch (error) {}
  }

  const updateLevelHandler = async () => {
    try {
      await dispatch(
        addEntityToKnowledgeGroup(selectedGroupId, 'quiz', [quizDetail._id]),
      )
      getQuiz(quizDetail._id)
    } catch (error) {}
  }

  const setErrorIfAny = async (temp: any, questionId: any) => {
    setIsLoading(false)
    setIsLoad(false)
    const questions: any[] = [...hasAnyError]
    questions.push(temp)
    ref.current.push(temp)
    setHasAnyError(questions)
    const hasInvalidOption = _.uniqBy(ref.current, 'id')
      .filter(function (el: any) {
        return el
      })
      .filter(function (el: any) {
        return el.invalid
      })
    if (
      ref.current.length === Object.keys(transformedQuestions).length &&
      hasInvalidOption.length === 0
    ) {
      const questionsAfterGrouping = _.uniqBy(ref.current, 'id')
      const toBeSaved: any[] = []

      questionsAfterGrouping.forEach((question: any) => {
        if (question.data) {
          let quiz_question_id: string = null
          let sub_quiz_question_id: string = null
          let subQuetion: any = null
          if (
            transformedQuestions[question.id] &&
            'quiz_question_id' in transformedQuestions[question.id]
          ) {
            quiz_question_id =
              transformedQuestions[question.id].quiz_question_id
          }
          question.data.forEach((subQuestion: any) => {
            let questionObject: any = {
              ...subQuestion,
              difficulty_level: subQuestion.hasOwnProperty('difficulty_level')
                ? subQuestion.difficulty_level
                : 1,
            }
            if (
              transformedQuestions[question.id] &&
              transformedQuestions[question.id].subquestions.length > 0
            ) {
              subQuetion = transformedQuestions[question.id].subquestions.find(
                (subQue: any) => subQue.id === subQuestion.id,
              )
              sub_quiz_question_id =
                subQuetion && 'quiz_question_id' in subQuetion
                  ? subQuetion.quiz_question_id
                  : null
            }

            if (quiz_question_id || sub_quiz_question_id) {
              questionObject = {
                ...questionObject,
                quiz_question_id: sub_quiz_question_id
                  ? sub_quiz_question_id
                  : !subQuetion && quiz_question_id
                    ? quiz_question_id
                    : null,
              }
            }

            // Delete only in case if there's no value
            if (!questionObject.quiz_question_id) {
              delete questionObject.quiz_question_id
            }

            toBeSaved.push(questionObject)
          })
        } else {
          let quiz_question_id: string = null
          if (
            transformedQuestions[question.id] &&
            'quiz_question_id' in transformedQuestions[question.id]
          ) {
            quiz_question_id =
              transformedQuestions[question.id].quiz_question_id
          }
          let questionObject: any = { ...question }
          if (quiz_question_id) {
            questionObject = {
              ...questionObject,
              quiz_question_id: quiz_question_id,
            }
          }
          toBeSaved.push(questionObject)
        }
      })

      updateQuizQuestions(
        toBeSaved,
        null,
        (typeof props.location.state !== 'undefined' &&
          props.location.state.selectedFileType) ||
          (props.location.state &&
            props.location.state.origin &&
            props.location.state.origin === 'create'),
      )
    }

    return
  }

  const updateQuizQuestionsFromParent = async () => {
    ref.current = []
    setQuizSubmitted(true)
    setHasAnyError([])
    setComponentHasError([])
    SetUpdatingQuizQuestionsFromParent(true)
    return
  }

  const updateQuizQuestions = async (
    toUpdateQuestions: any,
    operation: any = null,
    replaceHistory: boolean = false,
  ) => {
    computeTotalScore(toUpdateQuestions)
    let quizId = props.quizId ? props.quizId : props.match.params.quizId
    setIsLoading(true)
    setIsLoad(true)
    // const query = new URLSearchParams(useLocatio.search)
    try {
      const response: any = await dispatch(
        updateQuizAction(quizId, {
          questions: toUpdateQuestions,
        }),
      )
      setIsLoading(false)

      transformAllQuestions(response.quiz.questions)
      if (replaceHistory) {
        setIsLoad(false)
        getQuiz(quizId)
        history.replace(
          `/quizzes/edit/${quizId}${
            documentId && documentId.length > 0
              ? `?document=${documentId.join(',')}`
              : ''
          }`,
          undefined,
        )
        return
      } else {
        setIsLoad(false)
        getQuiz(quizId)
      }
    } catch (error) {
      setIsLoading(false)
      setIsLoad(false)
    }
  }

  const onQuizSave = async () => {
    let quizId = props.quizId ? props.quizId : props.match.params.quizId
    let _conditions: any[] = [...conditions]
    if (_conditions) {
      _conditions.map((part: any) => {
        if (part.test.question_id) {
          part.test.question_id = part.test.question_id.toString()
        }
        if (part.test.option_id) {
          part.test.option_id = part.test.option_id.toString()
        }
        if (part.show.message === null) {
          part.show.message = ''
        }
        if (!part.test.min_score || part.test.min_score === null) {
          part.test.min_score = 0
        }
        if (!part.test.max_score || part.test.max_score === null) {
          part.test.max_score = 0
        }
        return part
      })
    }

    let transformedLabels = []

    transformedLabels = selectedQuizLabels
      ? selectedQuizLabels.map(item => item.value)
      : []

    try {
      await dispatch(
        updateQuizAction(quizId, {
          name: quizName,
          display_mode: displayMode,
          description: quizDescription,
          display_questions_count: questionCount ? parseInt(questionCount) : 0,
          display_score: !hideMarks,
          is_required: markQuizRequired,
          is_welcome_enabled: isWelcomeEnabled,
          labels: transformedLabels,
          result_settings: {
            show_answers: showAnswer,
            show_scores: scoreAnswers ? showScore : false,
            show_scores_in_percentage:
              scoreAnswers && showScore ? showScoreInPercentage : false,
            show_button: showMainButton,
            button_label: mainButtonLabel,
            conditions: _conditions,
            score_answers: scoreAnswers,
          },
          score_decimal_number: parseInt(decimalPlaces),
        }),
      )
      setIsLoading(false)
      getQuiz(quizId)
    } catch (error) {}
  }

  const onDelete = () => {
    let tempQuestions = [...backupRef.current]

    tempQuestions = tempQuestions.filter((question, index) => {
      return !toBeDeleted.includes(question.id)
    })

    backupRef.current = tempQuestions
    transformAllQuestions(tempQuestions)

    let tempSavedQuestions = [...savedQuestions]
    tempSavedQuestions = tempSavedQuestions.filter((question, index) => {
      return !toBeDeleted.includes(question.id)
    })

    setSavedQuestions(tempSavedQuestions)
    generateQuestionIdLabelMap(tempSavedQuestions)
    transformQuizDropdownData(tempSavedQuestions)

    let toUpdateQuestions: any = []
    tempSavedQuestions.forEach(question => {
      if (question !== null) {
        toUpdateQuestions.push(question)
      }
    })
    !props.location.state?.createFromTestFile &&
      updateQuizQuestions(toUpdateQuestions)

    // setOpenConfirm(false);
    setSelectedNodes([])
    setToBeDeleted([])
    setOpenDeleteConfirm(false)
  }

  const directQuestionDelete = (questionId: any) => {
    setAddNew(false)
    let tempQuestions = [...backupRef.current]
    tempQuestions.forEach((question, index) => {
      if (questionId === question.id) {
        tempQuestions.splice(index, 1)
      }
    })
    backupRef.current = tempQuestions
    transformAllQuestions(tempQuestions)

    let tempSavedQuestions = [...savedQuestions]
    tempSavedQuestions.forEach((question, index) => {
      if (questionId === question.id) {
        tempSavedQuestions.splice(index, 1)
      }
    })
    setSavedQuestions(tempSavedQuestions)
    generateQuestionIdLabelMap(tempSavedQuestions)
    transformQuizDropdownData(tempSavedQuestions)

    let toUpdateQuestions: any[] = []
    tempSavedQuestions.forEach(question => {
      if (question !== null) {
        toUpdateQuestions.push(question)
      }
    })
    updateQuizQuestions(toUpdateQuestions, 'directDelete')
  }

  const onQuestionSort = (data: any) => {
    backupRef.current = data
    transformAllQuestions(data)

    let tempSavedQuestions = [...data]
    setSavedQuestions(tempSavedQuestions)
    generateQuestionIdLabelMap(tempSavedQuestions)
    transformQuizDropdownData(tempSavedQuestions)

    let toUpdateQuestions: any[] = []
    tempSavedQuestions.forEach(question => {
      if (question !== null) {
        toUpdateQuestions.push(question)
      }
    })
    updateQuizQuestions(toUpdateQuestions)
  }

  const onGroupQuestionSave = async (data: any, queIds: any) => {
    setAddNew(false)
    let tempQuestions = [...backupRef.current]
    data.forEach((questionToSave: any, mainIndex: any) => {
      tempQuestions.forEach((question, subIndex) => {
        if (queIds[mainIndex] === question.id) {
          tempQuestions[subIndex] = questionToSave
        }
      })
    })

    backupRef.current = tempQuestions
    transformAllQuestions(tempQuestions)

    let tempSavedQuestions = [...savedQuestions]
    data.forEach((questionToSave: any, mainIndex: any) => {
      tempSavedQuestions.forEach((question, subIndex) => {
        if (queIds[mainIndex] === question.id) {
          tempSavedQuestions[subIndex] = questionToSave
        }
      })
    })
    setSavedQuestions(tempSavedQuestions)
    generateQuestionIdLabelMap(tempSavedQuestions)
    transformQuizDropdownData(tempSavedQuestions)

    let toUpdateQuestions: any[] = []
    tempSavedQuestions.forEach(question => {
      if (question !== null) {
        toUpdateQuestions.push(question)
      }
    })
  }

  const confirmDelete = (questionId: any) => {
    let temp = []
    if (typeof questionId === 'string') {
      temp.push(questionId)
    } else {
      temp = [...questionId]
    }
    setToBeDeleted(temp)
    setOpenDeleteConfirm(true)
  }

  const addNewQuestion = (type: any = null, parentId: any = null) => {
    let emptyOptions: any = [...emptyQuestion.options]

    emptyOptions.forEach((option: any, index: any) => {
      emptyOptions[index] = {
        ...option,
        id: uuidv4(),
      }
    })

    emptyQuestion.options = emptyOptions

    let tempQuestions = [...backupRef.current]
    let newQ: any = { ...emptyQuestion }
    newQ.id = uuidv4()
    newQ.isNew = true

    if (type === 'sub') {
      newQ.parent_id = parentId
    }
    tempQuestions.push(newQ)
    transformAllQuestions(tempQuestions)
    backupRef.current = tempQuestions

    let tempSavedQuestions = [...savedQuestions]
    tempSavedQuestions.push(newQ)
    setSavedQuestions(tempSavedQuestions)

    if (!type) {
      setAddNew(true)
    }
  }

  const transformQuestion = (question: any) => {
    let temp = {
      ...question,
      score: !question.score || question.score === null ? 1 : question.score,
      position_check: question.position_check ? question.position_check : null,
    }
    if (question.options) {
      let opt: any[] = []
      question.options.forEach((option: any, index: any) => {
        opt[index] = {
          ...option,
          id: option.id || uuidv4(),
          text: option.text,
          is_correct: option.is_correct,
        }
      })
      temp.options = opt
    }
    return temp
  }

  const reorder = (list: any, startIndex: any, endIndex: any) => {
    const result = Array.from(list)
    const [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)

    return result
  }

  const onDrop = (dropResult: any) => {
    const { removedIndex, addedIndex } = dropResult
    if (addedIndex === undefined) {
      return
    }
    const temp = reorder(backupRef.current, removedIndex, addedIndex)
    onQuestionSort(temp)
  }

  const getChildPayload = (index: any) => {
    return backupRef.current[index]
  }

  const checkAllQuestionsValidity = () => {
    const incompleteQuestions: any = [] // Array to hold the IDs of incomplete questions
    // Iterate over the array of questions (assuming you have a list of questions)
    Object.values(transformedQuestions)?.map((question: any, index: number) => {
      if (question?.options && !question?.isNew) {
        let isCorrect = question?.options?.some(
          (option: any) => option?.is_correct === true,
        )
        if (!isCorrect) {
          incompleteQuestions?.push(`#${index + 1}`) // Add the question ID to the array if invalid
        }
      }
    })

    // If there are incomplete questions, show a toaster message
    if (incompleteQuestions?.length > 0) {
      if (incompleteQuestions?.length == 1) {
        helper.showToaster(
          t(
            `The quiz item ${incompleteQuestions?.join(
              ', ',
            )} is incomplete. Please complete all required items before submitting.`,
          ),
          'error',
        )
      } else {
        helper.showToaster(
          t(
            `The following quiz items are incomplete: ${incompleteQuestions?.join(
              ', ',
            )}. Please complete all required items before submitting.`,
          ),
          'error',
        )
      }
    }
  }

  // Call the function when the page loads
  useEffect(() => {
    if (Object.values(transformedQuestions)?.length > 0 && !addNew) {
      if (props.location.state?.fromQuizExtraction) {
        // Add delay for quiz extraction to ensure all components are rendered
        setTimeout(() => {
          checkAllQuestionsValidity()
        }, 500)
      } else {
        checkAllQuestionsValidity()
      }
    }
  }, [transformedQuestions])

  const renderItem = (question: any, index: any, questions: any) => {
    return (
      <div className="sortable-item">
        <QuizQuestionEditor
          checkAllQuestionsValidity={checkAllQuestionsValidity}
          questions={questions}
          essayConfig={essayConfig ? essayConfig?.params : null}
          isNew={question.isNew ? question.isNew : false}
          key={question.id || 'que_' + index}
          questionNumber={index}
          questionId={question.id || index}
          data={transformQuestion(question)}
          enableLearning={enableLearning}
          activateEditAsProps={
            typeof props.location.state !== 'undefined' &&
            props.location.state.selectedFileType
          }
          showEditableIfError={typeof props.location.state === 'undefined'}
          defaultEditable={fromQuizExtraction}
          updatingQuizQuestionsFromParent={updatingQuizQuestionsFromParent}
          SetUpdatingQuizQuestionsFromParent={
            SetUpdatingQuizQuestionsFromParent
          }
          hasAnyError={hasAnyError}
          onSetErrorIfAny={setErrorIfAny}
          updateQuizQuestionsFromParent={updateQuizQuestionsFromParent}
          parentRef={ref}
          hasLastIndex={index + 1 === Object.keys(transformedQuestions).length}
          onQuestionSave={() => {}}
          onQuestionDelete={confirmDelete}
          addNew={addNew}
          directQuestionDelete={directQuestionDelete}
          quizQuestionDropdownData={quizQuestionDropdownData}
          allQuestions={backupRef.current}
          addNewQuestion={addNewQuestion}
          onGroupQuestionSave={onGroupQuestionSave}
          addToSelectedRows={addToSelectedRows}
          selectedNodes={selectedNodes}
          showCheckbox={showSaveQuestionsToQuestionBank}
          isEssayGrader={essayGrader}
          enableDrag
          displayMode={displayMode}
        />
      </div>
    )
  }

  const getBuildQuizHtml = () => (
    <>
      {componentHasError.length > 0 &&
        typeof props.location.state !== 'undefined' &&
        props.location.state.selectedFileType &&
        quizSubmitted && (
          <div className="card-error">
            {t(
              'The questions were imported successfully but there are some errors in few of the questions. Please resolve the errors in the highlighted questions before saving',
            )}
          </div>
        )}

      <div>
        {backupRef.current.length === 0 && (
          <Typography variant="body3" mb={1} sx={{ textAlign: 'center' }}>
            {t(
              "You don't have any question yet. Click the button below to add a question.",
            )}
          </Typography>
        )}

        {Object.keys(transformedQuestions).length > 0 && (
          <DragContainer
            onDrop={onDrop}
            getChildPayload={getChildPayload}
            dragHandleSelector=".drag-handle"
          >
            {Object.keys(transformedQuestions).map(
              (questionId: any, index: any) => {
                return (
                  <Draggable key={questionId}>
                    {renderItem(
                      transformedQuestions[questionId],
                      index,
                      Object.values(transformedQuestions),
                    )}
                  </Draggable>
                )
              },
            )}
          </DragContainer>
        )}
        <Stack direction="row" justifyContent="center">
          <MuiButton
            variant="outlined"
            onClick={addNewQuestion}
            startIcon={<AddIcon fontSize="small" />}
          >
            {t('Create question from scratch')}
          </MuiButton>
        </Stack>
      </div>
    </>
  )

  ///////////////////// QUIZ EDITOR ////////////////////

  const updateCombinedQuizSettings = async () => {
    let quizId = props.quizId ? props.quizId : props.match.params.quizId
    let _conditions: any[] = [...conditions]
    if (_conditions) {
      _conditions.map((part: any) => {
        if (part.test.question_id) {
          part.test.question_id = part.test.question_id.toString()
        }
        if (part.test.option_id) {
          part.test.option_id = part.test.option_id.toString()
        }
        if (part.show.message === null) {
          part.show.message = ''
        }
        if (!part.test.min_score || part.test.min_score === null) {
          part.test.min_score = 0
        }
        if (!part.test.max_score || part.test.max_score === null) {
          part.test.max_score = 0
        }
        return part
      })
    }

    let transformedLabels = []
    transformedLabels = selectedQuizLabels
      ? selectedQuizLabels.map(item => item.value)
      : []

    try {
      setIsLoading(true)
      const response: any = await dispatch(
        updateQuizAction(quizId, {
          name: quizName,
          display_mode: displayMode,
          description: quizDescription,
          display_questions_count: questionCount ? parseInt(questionCount) : 0,
          display_score: !hideMarks,
          is_required: markQuizRequired,
          is_welcome_enabled: isWelcomeEnabled,
          labels: transformedLabels,
          result_settings: {
            show_answers: showAnswer,
            show_scores: scoreAnswers ? showScore : false,
            show_scores_in_percentage:
              scoreAnswers && showScore ? showScoreInPercentage : false,
            show_button: showMainButton,
            button_label: mainButtonLabel,
            conditions: _conditions,
            score_answers: scoreAnswers,
          },
          score_decimal_number: parseInt(decimalPlaces),
          ...(quizDetail?.type === 'roleplay' && {
            avatar_id: rolePlayAvatarId,
            voice_profile: selectedVoiceProfile?.value,
          }),
        }),
      )
      setIsLoading(false)
      getQuiz(quizId)
    } catch (error) {
      setIsLoading(false)
    }
  }

  const updateRolePlay = async () => {
    const quizId = props.quizId ? props.quizId : props.match.params.quizId
    const { id: questionId, type, text } = quizDetail.questions[0]

    setSaving(true)
    const scores = idealAnswerItems
      .filter((_, index) => index % 3 === 2)
      .map(t => Number.parseFloat(t.text))
    const score = scores.reduce(
      (accumulator, currentValue) => accumulator + currentValue,
      0,
    )

    const emptyFields = idealAnswerItems
      .filter((_, index) => index % 3 === 1)
      .find(t => t.text.length === 0)
    if (emptyFields) {
      helper.showToaster(t('Description of Assessment Criteria is required.'))
      setSaving(false)
      return
    }

    try {
      const response: any = await dispatch(
        updateQuizAction(quizId, {
          questions: [
            {
              id: questionId,
              type,
              text,
              roleplay_goal: rolePlayGoal,
              roleplay_tutor_role: rolePlayTutorRole,
              roleplay_learner_role: rolePlayLearnerRole,
              roleplay_scenario_description: rolePlayScenarioDescription,
              score: score || 1,
              position_check: 'rubric_description',
              scored_by: 'roleplay_grader',
              answer_key_settings: {
                headers: [
                  'Assessment Criteria',
                  'Description of Assessment Criteria',
                  'Score for Criteria(Optional)',
                ],
                column_headers: idealAnswerItems
                  .filter((_, index) => index % 3 === 0)
                  .map(t => t.text),
                row_count: newTableRowCount,
                column_count: newTableColumnCount,
              },
              ideal_answer_items: idealAnswerItems,
            },
          ],
        }),
      )
    } catch (e) {
    } finally {
      setSaving(false)
    }
  }

  const fetchAllLinkedQuizQuestionsHandler = async () => {
    setIsLoading(true)
    let quizId = props.quizId ? props.quizId : props.match.params.quizId
    await dispatch(getLinkedQuestionsBasedOnQuizAndQuestions(quizId))
    getQuiz(quizId)
  }

  const addToSelectedRows = (event: any, id: string) => {
    let data: any[] = [...selectedNodes]
    if (event.target.checked) {
      const isPresent = data.indexOf(id)
      if (isPresent < 0) {
        data.push(id)
      }
    } else {
      const oldData = [...selectedNodes]
      const index = oldData.indexOf(id)
      oldData.splice(index, 1)
      data = [...oldData]
    }
    setSelectedNodes([..._.uniq(data)])
  }

  const onSelectAllRows = (event: any) => {
    if (event.target.checked) {
      if (Object.keys(transformedQuestions).length > 0) {
        const quizzes: any = Object.keys(transformedQuestions)
        setSelectedNodes([..._.uniq(quizzes)])
      }
    } else {
      setSelectedNodes([])
    }
  }

  const saveQuestionsToQuestionBank = async () => {
    if (!selectedNodes.length) {
      return
    }

    let questions: any = []
    const transformedQuestion: any = { ...transformedQuestions }
    selectedNodes.forEach((id: string) => {
      if (
        transformedQuestion[id] &&
        transformedQuestion[id].text.trim().length
      ) {
        questions.push(transformedQuestion[id])
      }
    })

    if (questions.filter((q: any) => 'quiz_question_id' in q).length) {
      setShowKNowledgebaseOrNot(true)
    } else {
      updateQuestionsToQuestionBank()
    }
  }

  const updateQuestionsToQuestionBank = async () => {
    let questions: any = []
    const transformedQuestion: any = { ...transformedQuestions }
    let quizId = props.quizId ? props.quizId : props.match.params.quizId
    selectedNodes.forEach((id: string) => {
      if (
        transformedQuestion[id] &&
        transformedQuestion[id].text.trim().length
      ) {
        questions.push(transformedQuestion[id])
      }
    })

    let quizQuestionIds: any[] = []

    if (questions.length) {
      const createResponse: any = await dispatch(
        generateQuestionBankV2(
          quizId,
          {
            question_ids: questions.map((d: any) => d.id),
          },
          false,
        ),
      )
      createResponse?.quiz_questions.forEach((el: any) => {
        quizQuestionIds.push(el.id)
      })
      await getQuiz(quizId)
      setSelectedNodes([])
      helper.showToaster(t('Quiz questions has been saved.'), 'success')

      if (
        quizDetail.knowledge_group_ids &&
        quizDetail.knowledge_group_ids.length &&
        quizQuestionIds.length
      ) {
        await dispatch(
          bulkAssignModules(
            quizDetail.knowledge_group_ids[0],
            quizQuestionIds,
            'question',
            false,
          ),
        )
      }
    }
  }

  const addMoreQuestionToQuizHandler = async (
    question_ids: any[],
    quizId: any,
  ) => {
    const ids = question_ids.map((e: any) => e.rowId)
    setIsLoad(true)
    try {
      if (ids && ids.length > 0) {
        await dispatch(
          updateQuizAction(quizId, {
            question_ids: ids,
          }),
        )
        getQuiz(quizId)
      }
    } catch (error) {
      setIsLoad(false)
    }
  }

  const handleClickGenerateScenario = async () => {
    try {
      setIsLoadingScenario(true)
      const response = await commonService.generateScenarioSuggestion({
        assistant_role: rolePlayTutorRole,
        learner_role: rolePlayLearnerRole,
        scenario: rolePlayScenarioDescription || '',
      })

      if (response?.data?.data?.improved_scenario) {
        if (!rolePlayScenarioDescription) {
          setRolePlayScenarioDescription(
            response?.data?.data?.improved_scenario,
          )
        } else {
          setGeneratedScenario(response?.data?.data?.improved_scenario)
        }
      }
    } catch (error) {
      helper.showToaster(t('Failed to generate scenario'), 'error')
    } finally {
      setIsLoadingScenario(false)
    }
  }

  const downloadQuizzesHandler = async (
    exportQuiz: boolean = false,
    fileName: string,
  ) => {
    let quizData: any = {}
    const quizId = props.match.params.quizId
    quizData.quizzes = []
    if (exportQuiz) {
      quizData.quizzes.push({
        _id: quizId,
        question_ids: [],
      })
    } else {
      if (selectedNodes && selectedNodes.length > 0) {
        quizData.quizzes.push({
          _id: quizId,
          question_ids: [...selectedNodes],
        })
      }
    }
    try {
      const blob: any = await dispatch(exportQuizzesAndQuestions(quizData))
      if (!blob) {
        return
      }
      const url = window.URL.createObjectURL(new Blob([blob]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${fileName}.docx`)
      document.body.appendChild(link)
      link.click()
      link.parentNode.removeChild(link)
      setSelectedNodes([])
    } catch (error) {
      setSelectedNodes([])
    }
  }

  const QuestionHtml = () => {
    return (
      <>
        <div className="pl-lg-3">
          <div className="d-flex flex-wrap justify-content-between mb-3 align-items-start">
            <SectionHeader
              variant="tab"
              title={t('Quiz Questions')}
              subtitle={t('Manage your quiz questions and answers')}
            />
            <div className="action-btn-container d-flex align-items-center">
              {typeof props.location.state !== 'undefined' &&
                props.location.state.selectedFileType &&
                !props.location.state?.createFromTestFile && (
                  <button
                    onClick={
                      typeof props.location.state !== 'undefined' &&
                      props.location.state.selectedFileType
                        ? updateQuizQuestionsFromParent
                        : onQuizSave
                    }
                    className="btn btn-primary font-600 font-sm mr-2"
                  >
                    {t('Save Quiz')}
                  </button>
                )}
              <MuiButton onClick={() => downloadQuizzesHandler(true, quizName)}>
                {t('Export Quiz')}
              </MuiButton>
            </div>
          </div>

          {showSaveQuestionsToQuestionBank && (
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 pb-1">
              <Typography variant="body4">
                {t('Quiz Total Score:')}{' '}
                <Typography variant="body4" component="span" color="primary">
                  {quizTotalScore}
                </Typography>
              </Typography>
              {showSaveQuestionsToQuestionBank && (
                <CreateQuestionsOptions
                  knowledge_group_ids={
                    quizDetail &&
                    quizDetail.knowledge_group_ids &&
                    quizDetail.knowledge_group_ids.length
                      ? quizDetail.knowledge_group_ids[0]
                      : null
                  }
                  quizId={props.match.params.quizId}
                  addNewQuestion={addNewQuestion}
                  // toolkitSmartQuiz={toolkitSmartQuiz}
                  queTypes={
                    props.location &&
                    props.location.state &&
                    props.location.state.queTypes
                  }
                  addMoreQuestionToQuiz={addMoreQuestionToQuizHandler}
                  document_Id={documentId}
                />
              )}
            </div>
          )}

          <Stack direction="row" spacing={1} alignItems="center" mb={1}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={
                    Object.keys(transformedQuestions).length > 0 &&
                    selectedNodes.length ===
                      Object.keys(transformedQuestions).length
                  }
                  onChange={onSelectAllRows}
                />
              }
              label={t('Select all')}
            />

            {selectedNodes?.length > 0 && (
              <PermissionWrapper>
                <MuiButton onClick={saveQuestionsToQuestionBank}>
                  {t('Save Selected to Question Bank')}
                </MuiButton>

                <MuiButton
                  onClick={() => downloadQuizzesHandler(false, quizName)}
                >
                  {t('Export Selected')}
                </MuiButton>

                <MuiButton
                  color="error"
                  onClick={() => confirmDelete(selectedNodes)}
                >
                  {t('Delete Selected')}
                </MuiButton>
              </PermissionWrapper>
            )}
          </Stack>

          {typeof props.location.state !== 'undefined' &&
            props.location.state.selectedFileType && (
              <div className="extract-quiz-wrapper d-flex flex-wrap edit-extract-quiz">
                <QuizDocumentPreview
                  documentContent={docContent}
                  documentType={props.location.state.documentType}
                />
                <div className="extract-quiz-questions mt-3 mt-md-0">
                  {getBuildQuizHtml()}
                </div>
              </div>
            )}

          {!(
            typeof props.location.state !== 'undefined' &&
            props.location.state.selectedFileType
          ) && getBuildQuizHtml()}
        </div>
      </>
    )
  }

  const getQuizHtml = () => {
    return (
      <Tabs
        defaultActiveKey={activeTab}
        activeKey={activeTab}
        onSelect={(e: string | null) => {
          if (!e) return
          setActiveTab(e)
          const params = new URLSearchParams(history.location.search)
          params.set('activeTab', e)
          history.replace({
            pathname: history.location.pathname,
            search: params.toString(),
          })
        }}
      >
        {quizDetail?.type !== 'roleplay' ? (
          <Tab eventKey="admins" title={t('Questions')}>
            {QuestionHtml()}
          </Tab>
        ) : (
          <Tab eventKey="admins" title={t('Role Play')}>
            <div className="d-flex flex-wrap justify-content-between mb-24 align-items-start">
              <div>
                <SectionTypography
                  title={t('Role Play Context')}
                  subtitle={t(
                    'Set the scene and define the key details for your role play scenario.',
                  )}
                />
              </div>
              <button
                className="btn btn-primary font-600"
                onClick={updateRolePlay}
                disabled={isSaving}
              >
                {t('Save')}
              </button>
            </div>

            <div className="tw-flex tw-flex-col tw-gap-4 tw-text-text">
              <div>
                <SectionTypography
                  title={t('AI Assistant Role')}
                  subtitle={t(
                    'Define the AI assistant’s role in this role play.',
                  )}
                />
                <textarea
                  className="mt-3 tw-border tw-b order-border tw-rounded-lg tw-text-sm tw-w-full tw-px-3 tw-py-2 tw-outline-none"
                  // placeholder="What part will the tutor play in this role play scenario?"
                  placeholder={
                    t(
                      'Will it act as a mentor, interviewer, customer, or another character? What perspective or behaviour should it adopt?',
                    ) +
                    '\n' +
                    t(
                      'E.g: The AI assistant will act as an interviewer for a marketing assistant role, asking behavioural and technical questions',
                    )
                  }
                  value={rolePlayTutorRole}
                  onChange={e => setRolePlayTutorRole(e.currentTarget.value)}
                />
              </div>

              <div>
                <SectionTypography
                  title={t('Learner Role')}
                  subtitle={t(
                    'Define the role the learner will take in this role play.',
                  )}
                />
                <textarea
                  className="mt-3 tw-border tw-b order-border tw-rounded-lg tw-text-sm tw-w-full tw-px-3 tw-py-2 tw-outline-none"
                  // placeholder="What part will the learner play in this role play scenario?"
                  placeholder={
                    t(
                      'Describe the learner’s role and objectives in this role play. What are they trying to achieve, learn, or demonstrate?',
                    ) +
                    '\n' +
                    t(
                      'E.g: The learner will play a job candidate applying for a marketing assistant role. Their objective is to present themselves confidently, answer questions clearly, and showcase their skills to secure the position.',
                    )
                  }
                  value={rolePlayLearnerRole}
                  onChange={e => setRolePlayLearnerRole(e.currentTarget.value)}
                />
              </div>

              <div className="suneditor-container">
                <div className="tw-flex tw-justify-between tw-items-center">
                  <div>
                    <SectionTypography
                      title={t('Scenario Description')}
                      subtitle={t(
                        'Set the context for the role play interaction.',
                      )}
                    />
                  </div>

                  <MuiButton
                    onClick={() => handleClickGenerateScenario()}
                    color="tertiary"
                    variant="contained"
                    disabled={
                      isLoadingScenario ||
                      !rolePlayTutorRole ||
                      !rolePlayLearnerRole
                    }
                    loadingPosition="start"
                    loading={isLoadingScenario}
                    startIcon={<AutoAwesomeOutlinedIcon fontSize="small" />}
                  >
                    {t(isLoadingScenario ? t('Generating...') : t('AI Assist'))}
                  </MuiButton>
                </div>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    bgcolor: '#FDF2C8',
                    border: '1px solid #F9BD2A',
                    borderRadius: '8px',
                    padding: '12px 16px',
                    my: '12px',
                  }}
                >
                  <ErrorRoundedIcon sx={{ color: '#F9BD2A' }} />
                  <Typography
                    component="h5"
                    sx={{ fontSize: '14px', color: '#07135F' }}
                  >
                    {t(
                      'Tip: Fill out the AI Assistant Role and Learner Role fields first to create a more specific scenario.',
                    )}
                  </Typography>
                </Box>

                <Contenteditable
                  loading={isLoadingScenario && !rolePlayScenarioDescription}
                  value={rolePlayScenarioDescription}
                  onChange={(content: string) =>
                    setRolePlayScenarioDescription(content)
                  }
                  placeholder={t(
                    'Provide an outline of the scenario or context to shape a meaningful role play learning experience.e.g: A customer calls in to report an issue with their recent purchase. The learner will play the role of customer support, helping the customer troubleshoot and resolve the issue.',
                  )}
                />

                {generatedScenario && (
                  <div className="tw-mt-3 tw-p-4 tw-bg-[#FEE5F4] tw-rounded-md">
                    <div className="tw-mb-4 tw-flex tw-items-center">
                      <AutoAwesomeOutlinedIcon
                        fontSize="small"
                        className="tw-mr-2"
                      />
                      {t('Improve with AI')}
                      <IconButton
                        sx={{ marginLeft: 'auto' }}
                        onClick={() => {
                          setGeneratedScenario('')
                        }}
                      >
                        <CloseIcon color="primary" fontSize="small" />
                      </IconButton>
                    </div>
                    <div className="tw-p-4 tw-border tw-border-gray-300 tw-rounded-md">
                      <Contenteditable value={generatedScenario} viewMode />
                    </div>
                    <div className="tw-flex tw-justify-end tw-gap-2 tw-mt-4">
                      <Button
                        variant="outline"
                        className="tw-border-gray-300"
                        onClick={() => {
                          navigator.clipboard.writeText(generatedScenario)
                          helper.showToaster(
                            t('Copied to clipboard'),
                            'success',
                          )
                        }}
                      >
                        {t('Copy Text')}
                      </Button>
                      <Button
                        onClick={() => {
                          setRolePlayScenarioDescription(generatedScenario)
                          setGeneratedScenario('')
                        }}
                      >
                        {t('Replace Current')}
                      </Button>
                    </div>
                  </div>
                )}
              </div>

              <div className="tw-flex tw-items-center tw-justify-between">
                <div>
                  <SectionTypography
                    title={t('Skills Assessment')}
                    subtitle={t(
                      'Let the AI handle the scoring. Just provide the criteria, and the AI will automatically assign points based on your descriptions.',
                    )}
                  />
                </div>
              </div>

              <div className="rubric-scoring-table tw-relative tw-pb-4">
                <SkillsAssetment
                  maxCharCount={4000}
                  onAnswerKeyTableChange={onAnswerKeyTableChange}
                  tableValues={tableValues}
                  horizontalHeaderValues={[
                    t('Assessment Criteria'),
                    t('Description of Assessment Criteria'),
                    t('Score for Criteria (Optional)'),
                  ]}
                  scoredBy={{
                    value: 'similar_match',
                    label: 'Matching similar sentences',
                  }}
                />
              </div>
            </div>
          </Tab>
        )}
        {quizDetail?.type !== 'roleplay' && (
          <Tab eventKey="feedback" title={t('Feedback & Tutoring')}>
            {activeTab === 'feedback' && (
              <>
                <FeedbackAndTutoring
                  isFeedback
                  conditions={conditions}
                  transformData={transformData}
                  buttonOptions={buttonOptions}
                  quizQuestionDropdownData={quizQuestionDropdownData}
                  removeScoreCondition={removeScoreCondition}
                  onConditionFieldChange={onConditionFieldChange}
                  onConditionQuestionDropdownChange={
                    onConditionQuestionDropdownChange
                  }
                  onButtonAdd={onButtonAdd}
                  onButtonLabelEdit={onButtonLabelEdit}
                  onButtonQuestionSelect={onButtonQuestionSelect}
                  onSort={onSort}
                  deleteButtonRow={deleteButtonRow}
                  questionIdLabelMap={questionIdLabelMap}
                  totalQuizScore={totalQuizScore}
                  updateCombinedQuizSettings={updateCombinedQuizSettings}
                  quizId={
                    props.quizId ? props.quizId : props.match.params.quizId
                  }
                  transformedQuestions={transformedQuestions}
                  getQuiz={getQuiz}
                  fetchAllLinkedQuizQuestions={
                    fetchAllLinkedQuizQuestionsHandler
                  }
                />
                <div className="d-flex align-items-center justify-content-center px-2">
                  <PermissionWrapper>
                    <MuiButton
                      variant="outlined"
                      startIcon={<AddIcon />}
                      onClick={() => {
                        addScoreRangeCondition(true)
                      }}
                    >
                      {t('Add Another Response')}
                    </MuiButton>
                  </PermissionWrapper>
                </div>
              </>
            )}
          </Tab>
        )}
        <Tab eventKey="level" title={t('Level')}>
          {activeTab === 'level' && (
            <>
              <KGroupsTree
                onSelectGroup={group => {
                  setSelectedGroupId(group?._id || null)
                  setIsGroupValid(group?._id && group?._id !== 'undefined')
                }}
                syncsState={false}
                initialSelectedGroupId={selectedGroupId}
              />
              <Stack direction="row" className="mt-3" justifyContent="flex-end">
                <MuiButton
                  variant="contained"
                  onClick={updateLevelHandler}
                  disabled={!isGroupValid}
                >
                  {t('Save')}
                </MuiButton>
              </Stack>
            </>
          )}
        </Tab>
        <Tab
          eventKey="settings"
          title={
            quizDetail?.type !== 'roleplay'
              ? t('Quiz Settings')
              : t('Role Play Settings')
          }
        >
          <>
            <div className="d-flex flex-wrap justify-content-between mb-24 align-items-start">
              <div>
                <Typography variant="body1">
                  {quizDetail?.type !== 'roleplay'
                    ? t('Quiz Settings')
                    : t('Role Play Settings')}
                </Typography>
                <Typography variant="body2">
                  {quizDetail?.type !== 'roleplay'
                    ? t('Manage quiz mode and details.')
                    : t('Manage role play details.')}
                </Typography>
              </div>
              <MuiButton
                variant="contained"
                onClick={updateCombinedQuizSettings}
              >
                {t('Save')}
              </MuiButton>
            </div>
            <Row>
              <Col md={6}>
                <div className="form-group mb-32">
                  <label className="font-16 font-600">
                    {quizDetail?.type !== 'roleplay'
                      ? t('Quiz Name')
                      : t('Role Play Name')}
                  </label>
                  <input
                    type="text"
                    placeholder={
                      quizDetail?.type !== 'roleplay'
                        ? 'Name of role play'
                        : 'Name of quiz'
                    }
                    className="form-control h-auto py-1"
                    value={quizName || ''}
                    onChange={(e: any) => {
                      onFieldChange(e.target.value, 'name')
                    }}
                  />
                  {quizDetail?.type !== 'roleplay' && (
                    <div className="d-flex flex-wrap mt-2">
                      <div className="tw-mt-2">
                        <Toggle
                          toggled={markQuizRequired}
                          onToggle={(event: any) => {
                            setMarkQuizRequired(event.target.checked)
                          }}
                          label={t('Mark quiz as required')}
                          InputPosition="start"
                        />
                      </div>
                      <div className="tw-mt-2">
                        <Toggle
                          toggled={isWelcomeEnabled}
                          onToggle={(event: any) => {
                            setIsWelcomeEnabled(event.target.checked)
                          }}
                          label={t('Show welcome screen')}
                          InputPosition="start"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </Col>
              <Col md={6}>
                <div className="form-group mb-32">
                  <label className="font-16 font-600">
                    {quizDetail?.type !== 'roleplay'
                      ? t('Quiz Description')
                      : t('Role Play Description')}
                  </label>
                  <textarea
                    placeholder={
                      quizDetail?.type !== 'roleplay'
                        ? 'Description of quiz'
                        : 'Description of role play'
                    }
                    className="form-control radius-10 border-grey"
                    value={quizDescription || ''}
                    onChange={(e: any) => {
                      onQuizDescriptionChange(e.target.value)
                    }}
                  ></textarea>
                </div>
              </Col>
              {/* Voice Profile Dropdown for Role Play Settings */}
              {quizDetail?.type === 'roleplay' && (
                <Col md={12}>
                  <div className="form-group mb-32">
                    <h3 className="tw-text-base font-16 font-600">
                      {t('Select Role Play Voice')}
                    </h3>
                    <p className="tw-text-base">
                      {t(
                        'How should your role play character sound when speaking',
                      )}
                    </p>
                    <div className="tw-flex tw-items-center tw-gap-3">
                      <div className="tw-flex-1">
                        <Select
                          isSearchable
                          className="tw-w-full tw-border tw-border-[#8F94A3] tw-rounded-md tw-outline-none voice-profile-dropdown"
                          classNamePrefix="select-target-prefix"
                          components={{
                            DropdownIndicator: () => (
                              <Image
                                className="mr-2"
                                src={dropDownBlue}
                                alt="dropdown arrow"
                              />
                            ),
                            IndicatorSeparator: () => null,
                          }}
                          defaultValue={selectedVoiceProfile}
                          value={selectedVoiceProfile}
                          options={voiceProfiles}
                          onChange={(e: any) => {
                            setSelectedVoiceProfile({
                              value: e?.value,
                              label: e?.label,
                            })
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              )}
              {/* AvatarPicker for Role Play Settings */}
              {quizDetail?.type === 'roleplay' &&
                !agentData?.settings?.chat_is_avatar_disabled && (
                  <Col md={12}>
                    <div className="form-group mb-32">
                      <label className="font-16 font-600 mb-0">
                        {t('Select Role Play Avatar')}
                      </label>
                      <p className="tw-text-base tw-mb-2">
                        {t(
                          'Choose which avatar will represent the character in your role play scenario.',
                        )}
                      </p>

                      {(() => {
                        const selectedAvatarId =
                          rolePlayAvatarId && rolePlayAvatarId.trim() !== ''
                            ? rolePlayAvatarId
                            : agentData?.settings?.avatar_id

                        return (
                          <AvatarPicker
                            agentSettings={agentData}
                            disabled={false}
                            selectedAvatarId={selectedAvatarId}
                            onChange={(partial: any) => {
                              if (partial?.avatar_id) {
                                setRolePlayAvatarId(partial.avatar_id)
                              }
                            }}
                          />
                        )
                      })()}
                    </div>
                  </Col>
                )}

              {quizDetail?.type !== 'roleplay' && (
                <Col md={6}>
                  <div className="form-group mb-32">
                    <label className="font-16 font-600">
                      {t('Number of Question shown')}
                    </label>
                    <div>
                      {t(
                        'You can create a pool of questions and select how many of them you want to show in the quiz. The questions will be selected randomly. All questions will be shown if no value is entered.',
                      )}
                    </div>
                    <div className="d-flex align-items-center mt-2">
                      {/* <span className="border-grey form-control font-sm clr-black h-auto w-auto py-1 mr-1">
                  123
                </span> */}

                      <input
                        className="border-grey form-control font-sm clr-black h-auto w-auto py-1 mr-1"
                        type="number"
                        name="no_of_question_shown"
                        value={questionCount || 0}
                        onChange={(e: any) => setQuestionCount(e.target.value)}
                        min="1"
                        max={backupRef.current.length.toString()}
                      />
                      <button
                        className="btn clr-red border-0 font-sm py-0 font-600"
                        onClick={() => {
                          setQuestionCount(null)
                        }}
                      >
                        {t('Clear')}
                      </button>
                    </div>
                  </div>
                </Col>
              )}
              {quizDetail?.type !== 'roleplay' && (
                <Col md={6}>
                  <div className="form-group mb-32">
                    <label className="font-16 font-600">
                      {t('Number of decimal places in score')}
                    </label>
                    <div>
                      {t(
                        'You can set how many decimal places the quiz score should have.',
                      )}
                    </div>
                    <div className="d-flex alignitems-center mt-2">
                      <input
                        className="border-grey form-control font-sm clr-black h-auto w-auto py-1 mr-1"
                        type="number"
                        name="no_of_decimal_shown"
                        value={decimalPlaces}
                        onChange={(e: any) => setDecimalPlaces(e.target.value)}
                        min="1"
                        max="5"
                      />
                    </div>
                  </div>
                </Col>
              )}
            </Row>

            <div className="mb-32">
              {quizDetail?.type !== 'roleplay' && (
                <>
                  <label className="font-16 font-600 mb-0">
                    {t('Quiz Format')}
                  </label>
                  <div className="upload-list-msg d-flex align-items-center font-12 py-2 my-3">
                    <img src={infoIcon} alt="" className="mr-3" />
                    {t(
                      'Warning: Select “One at a time” if your quiz has logic/branching. Logic added to a quiz question is not supported in “All in one page” and "Conversational" modes.',
                    )}
                  </div>
                  <ButtonGroup className="quiz-btn-group border-grey radius-8 w-100 mb-3">
                    {[
                      {
                        value: 'single_question',
                        label: t('One at a time'),
                      },
                      {
                        value: 'continuous_scroll',
                        label: t('All in one page'),
                      },
                      {
                        value: 'conversational_v2',
                        label: t('Conversational'),
                      },
                    ].map((d: any) => {
                      return (
                        <Button
                          onClick={() => {
                            setDisplayMode(d.value)
                          }}
                          variant="default"
                          className={displayMode === d.value ? 'active' : ''}
                        >
                          {d.label}
                        </Button>
                      )
                    })}
                  </ButtonGroup>
                  {displayMode !== 'conversational_v2' && (
                    <div className="tw-mt-2">
                      <Toggle
                        toggled={hideMarks}
                        onToggle={event => setHideMarks(event.target.checked)}
                        label={t('Hide marks per question')}
                        InputPosition="start"
                      />
                    </div>
                  )}
                </>
              )}

              <div>
                <label className="font-16 font-600 mb-1">
                  {t('Configure Results')}
                </label>
                <div className="mb-3">
                  {quizDetail?.type !== 'roleplay'
                    ? t(
                        'Customize messages, buttons and more in the quiz results screen. User will see this after the quiz completion along with exercise reports.',
                      )
                    : t(
                        'Customize messages, buttons and more in the role play results screen. User will see this after the role play completion along with exercise reports.',
                      )}
                </div>
                <div className="mb-32">
                  {/* Role play feedback toggle only for roleplay type */}
                  {quizDetail?.type === 'roleplay' && (
                    <div className="tw-mt-2">
                      <Toggle
                        toggled={scoreAnswers}
                        onToggle={event => {
                          const checked = event.target.checked
                          setScoreAnswers(checked)
                          if (!checked) {
                            setShowScore(false)
                            setShowScoreInPercentage(false)
                          }
                        }}
                        label={t('Send feedback for role play')}
                        InputPosition="start"
                      />
                    </div>
                  )}

                  {(quizDetail?.type !== 'roleplay' || scoreAnswers) && (
                    <div className="tw-mt-2">
                      <Toggle
                        toggled={showScore}
                        onToggle={event => {
                          const checked = event.target.checked
                          setShowScore(checked)
                          if (!checked) {
                            setShowScoreInPercentage(false)
                          }
                        }}
                        label={
                          quizDetail?.type === 'roleplay'
                            ? t('Include scores in feedback')
                            : t('Show scores in the results')
                        }
                        InputPosition="start"
                      />
                    </div>
                  )}

                  {showScore && (
                    <div className="tw-mt-2">
                      <Toggle
                        toggled={showScoreInPercentage}
                        onToggle={event =>
                          setShowScoreInPercentage(event.target.checked)
                        }
                        label={t('Show scores in percentage')}
                        InputPosition="start"
                      />
                    </div>
                  )}

                  {displayMode !== 'conversational_v2' && (
                    <>
                      <div className="tw-mt-2">
                        <Toggle
                          toggled={showAnswer}
                          onToggle={(event: any) =>
                            setShowAnswer(event.target.checked)
                          }
                          label={t('Show answers in the quiz results')}
                          InputPosition="start"
                        />
                      </div>

                      <div className="tw-mt-2">
                        <Toggle
                          toggled={showMainButton}
                          onToggle={(event: any) =>
                            setShowMainButton(event.target.checked)
                          }
                          label={t('Show main button in the quiz results')}
                          InputPosition="start"
                        />
                      </div>
                    </>
                  )}
                </div>

                {showMainButton && displayMode !== 'conversational_v2' && (
                  <div className="form-group mb-32">
                    <label className="font-16 font-600">
                      {t('Button label')}
                    </label>
                    <input
                      type="text"
                      placeholder="Button label"
                      className="form-control h-auto py-1"
                      value={mainButtonLabel || ''}
                      onChange={(e: any) => {
                        setMainButtonLabel(e.target.value)
                      }}
                    />
                  </div>
                )}
              </div>
            </div>

            <div>
              <div className="d-flex flex-wrap justify-content-between mb-3 align-items-center">
                <label className="font-16 font-600 mb-0">
                  {t('Post Submission Response')}
                </label>
                <MuiButton
                  startIcon={<AddIcon />}
                  onClick={() => addScoreRangeCondition(false)}
                >
                  {t('Add Another Response')}
                </MuiButton>
              </div>

              {conditions.map((item, index) => {
                return (
                  <ScoreRange
                    key={item.id ? item.id : index.toString()}
                    buttonsData={item.show.buttons ? item.show.buttons : []}
                    buttonOptions={buttonOptions}
                    quizQuestionDropdownData={quizQuestionDropdownData}
                    conditionData={item}
                    conditionIndex={index}
                    removeScoreCondition={removeScoreCondition}
                    onConditionFieldChange={onConditionFieldChange}
                    onConditionQuestionDropdownChange={
                      onConditionQuestionDropdownChange
                    }
                    onButtonAdd={onButtonAdd}
                    onButtonLabelEdit={onButtonLabelEdit}
                    onButtonQuestionSelect={onButtonQuestionSelect}
                    onSort={onSort}
                    deleteButtonRow={deleteButtonRow}
                    questionIdLabelMap={questionIdLabelMap}
                    totalQuizScore={totalQuizScore}
                  />
                )
              })}
            </div>

            {quizDetail?.type !== 'roleplay' && quizDetail && (
              <ReportAlerts quizId={quizDetail._id} />
            )}
          </>
        </Tab>
      </Tabs>
    )
  }

  const saveQuestionsToBank = () => {
    updateQuizQuestionsFromParent()
  }

  if (isLoad || IsLoading) {
    return <Loading />
  }

  return (
    <>
      <TwoButtonModal
        show={showKNowledgebaseOrNot}
        leftButtonText={t('Cancel')}
        rightButtonText={t('Save')}
        title={t('Save to knowledge base')}
        message={`<span>There are selected question(s) have already been saved in question bank. By choosing to save, the saved question <b style="color: #FF009E;">would be overwritten.</b></span>`}
        innerHtml={true}
        size={'lg'}
        leftButtonClassName="btn btn-outline-primary mr-3"
        rightButtonClassName="btn btn-primary mr-3"
        onClickClose={() => {
          setShowKNowledgebaseOrNot(false)
        }}
        onClickLeftButton={() => {
          setShowKNowledgebaseOrNot(false)
        }}
        onClickRightButton={() => {
          setShowKNowledgebaseOrNot(false)
          updateQuestionsToQuestionBank()
        }}
      />

      <section
        className={classNames({
          'page-mid-wraper': true,
          'create-test-file': props.location.state?.createFromTestFile,
          'h-without-foter':
            activeTab !== 'admins' || props.location.state?.createFromTestFile, //  && activeKey !== "feedback",
        })}
      >
        <div>
          {quizDetail && (
            <>
              <ChildPageHeader
                title={quizDetail?.name}
                subTitle={
                  quizDetail?.type !== 'roleplay'
                    ? t('Manage your quiz questions and settings')
                    : t('Manage your role play settings')
                }
              />
              <div className="">
                {getQuizHtml()}
                <ConfirmationModal
                  message={t('Are you sure you want to delete this question?')}
                  size={'md'}
                  show={openDeleteConfirm}
                  onHide={() => setOpenDeleteConfirm(false)}
                  confirmHandler={onDelete}
                />
              </div>
            </>
          )}
        </div>
      </section>

      {isCreateFromTestFile && activeTab === 'admins' && (
        <footer>
          <div>
            <div className="d-flex align-items-center justify-content-end px-2">
              <PermissionWrapper>
                <MuiButton
                  variant="outlined"
                  onClick={() => {
                    !IsLoading && saveQuestionsToBank()
                  }}
                >
                  {t('Save and Generate Keywords')}
                </MuiButton>
              </PermissionWrapper>
            </div>
          </div>
        </footer>
      )}
    </>
  )
}

export default EditCreateQuiz
